import { useState } from "react";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const [uid, setUid] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setErr("");
    try { await login(uid.trim(), pw); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="login-overlay" data-testid="login-page">
      <div className="login-visual">
        <div className="login-visual-inner">
          <img src="/honglu-logo.png" alt="HONGLU" className="login-logo" />
          <h1>PT HONGLU BAJA INDONESIA</h1>
          <div className="login-sub">WAREHOUSE BARCODE SYSTEM / 仓库条码系统</div>
          <p>Sistem terintegrasi untuk pengelolaan material, barcode, stok area, pencatatan transaksi, dan verifikasi.<br />物料、条码、区域库存、交易记录与验证一体化管理系统。</p>
          <div className="login-chips"><span>✓ Barcode &amp; QR / 条码与二维码</span><span>✓ Stok Area / 区域库存</span><span>✓ Log Audit / 审计记录</span></div>
        </div>
      </div>
      <div className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <div className="login-mobile-brand"><img src="/honglu-logo.png" alt="" /><b>PT HONGLU BAJA INDONESIA</b></div>
          <h2>Selamat Datang / 欢迎</h2>
          <div className="login-title2">Login Pengguna / 用户登录</div>
          <p className="login-desc">Masuk menggunakan ID Pengguna dan Kata Sandi yang terdaftar. / 使用已登记的用户ID和密码登录。</p>
          <label>ID Pengguna / 用户ID</label>
          <input value={uid} onChange={(e) => setUid(e.target.value)} placeholder="Contoh / 示例: MC-001" autoFocus data-testid="login-userid-input" />
          <label>Kata Sandi / 密码</label>
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Kata Sandi / 密码" data-testid="login-password-input" />
          {err && <div className="alert error" data-testid="login-error">{err}</div>}
          <button className="btn btn-primary btn-login" disabled={busy} data-testid="login-submit-btn">{busy ? "MEMPROSES... / 处理中" : "MASUK KE SISTEM / 登录"}</button>
          <div className="login-note">🔒 Wajib login setiap membuka aplikasi / 每次打开应用都必须登录</div>
        </form>
      </div>
    </div>
  );
}
